@if (content(); as c) {
    @let subheadline = locationHeadline();
    @let url = dealerHcmUrl();
    <section class="bg-grey-100 px-24 pt-16 pb-12 md:hidden">
        <h1 class="text-31 leading-36">{{ c.heroHeadline }}</h1>
        @if (subheadline) {
            <h2 class="text-16 leading-27">{{ subheadline }}</h2>
        }
    </section>

    <section>
        <ui-m030-c020-teaser-allrounder
            [strongText]="c.heroBulletListHeadline ?? undefined"
            [list]="heroBullets() ?? undefined"
            [image]="c.heroImage?.url ?? ''"
            [imageAlt]="c.heroImage?.alt || (c.heroHeadline ?? '')"
            isFirstView
            greyBackground
        >
            <h1 class="hidden md:block" headline>{{ c.heroHeadline }}</h1>
            @if (subheadline) {
                <h2 class="mb-24 hidden md:block" subheadline>{{ subheadline }}</h2>
            }

            @if (!isOverlay()) {
                <ng-container cta>
                    @if (dealer() && dealer().hasMobileSellerId && c.heroCtaText; as cta) {
                        @if (url) {
                            <a
                                class="button-primary w-full lg:w-max"
                                [hyundaiRouterLink]="url"
                                [trackingElTarget]="url"
                                [trackingElLabel]="cta"
                                trackingElType="button"
                                tracking
                            >
                                {{ cta }}
                            </a>
                        } @else {
                            <a
                                class="button-primary w-full lg:w-max"
                                hyundaiRouterLink="/fahrzeugbestand"
                                trackingElTarget="/fahrzeugbestand"
                                trackingElType="button"
                                tracking
                                trackingElLabel="Vehicle Market List"
                            >
                                {{ cta }}
                            </a>
                        }
                    }
                </ng-container>
            }
        </ui-m030-c020-teaser-allrounder>
    </section>

    <section class="bg-white">
        <div class="inner-page-wrapper pt-24 pb-40 lg:pt-64">
            <h2 class="text-24 lg:text-34 mb-24 leading-28 lg:mb-64 lg:text-center lg:leading-41">
                {{ c.contentHeadline }}
            </h2>
            <div class="contents flex-row lg:flex lg:gap-56">
                <div class="lg:w-1/2 lg:flex-1">
                    @if (c.contentImage; as image) {
                        <ui-m000-c010-image
                            class="bg-grey-100"
                            [alt]="image.alt ?? ''"
                            [image]="{
                                image: image.url,
                                desktop: { width: 800, height: 600 },
                                tablet: { width: 800, height: 500 },
                                mobile: { width: 700, height: 280 },
                            }"
                            priority
                            cover
                        />
                    }
                    @let contentCopy = c.contentCopy || '' | footnotes;
                    <p class="text-16 py-24 leading-27" [innerHTML]="contentCopy()"></p>
                </div>

                <div class="flex flex-col gap-12 pt-12 lg:w-1/2 lg:flex-1 lg:pt-0">
                    <h3 class="text-16 lg:text-22 leading-27 lg:leading-28" id="vorteile">
                        {{ c.contentBulletListHeadline }}
                    </h3>
                    <ul class="flex flex-col gap-12">
                        @for (item of c.contentBulletList; track $index) {
                            <li class="flex items-center gap-8 wrap-break-word">
                                @if (item.icon; as icon) {
                                    <ui-m000-c010-image
                                        class="shrink-0 self-start"
                                        [image]="{
                                            image: icon.url,
                                            desktop: { width: 40, height: 40 },
                                            tablet: { width: 40, height: 40 },
                                            mobile: { width: 40, height: 40 },
                                        }"
                                        alt=""
                                        classList="size-34  lg:size-40 aspect-square"
                                        priority="false"
                                        cover
                                        aria-hidden="true"
                                    />
                                } @else {
                                    <i class="icon-placeholder text-34 lg:text-[40px]" aria-hidden="true"></i>
                                }
                                @let itemText = item.text | footnotes;
                                <p class="wrap-break-word" [innerHTML]="itemText()"></p>
                            </li>
                        }
                    </ul>
                    @if (!isOverlay() && dealer() && dealer().hasMobileSellerId) {
                        @if (c.heroBulletListLinkText; as cta) {
                            @if (url) {
                                <a
                                    class="button-primary mt-8 lg:w-max"
                                    [hyundaiRouterLink]="url"
                                    [trackingElTarget]="url"
                                    [trackingElLabel]="cta"
                                    trackingElType="button"
                                    tracking
                                >
                                    {{ cta }}
                                </a>
                            } @else {
                                <a
                                    class="button-primary mt-8 lg:w-max"
                                    hyundaiRouterLink="/fahrzeugbestand"
                                    trackingElTarget="/fahrzeugbestand"
                                    trackingElType="button"
                                    tracking
                                    trackingElLabel="Vehicle Market List"
                                >
                                    {{ cta }}
                                </a>
                            }
                        }
                    }
                </div>
            </div>
        </div>
    </section>
    <section class="bg-white">
        <div class="inner-page-wrapper pt-24 pb-40">
            <div class="flex flex-col gap-24 lg:flex-row lg:gap-56">
                <div class="flex flex-col gap-12 pt-12 lg:w-1/2 lg:flex-1 lg:pt-0">
                    <h3 class="text-24 lg:text-34 leading-28 lg:leading-41" id="videoHeadline">
                        {{ c.videoHeadline }}
                    </h3>
                    @let videoCopy = c.videoCopy || '' | footnotes;
                    <p class="text-16 leading-27" [innerHTML]="videoCopy()"></p>

                    @if (c.videoCtaText; as cta) {
                        @if (c.videoCtaTarget) {
                            <a
                                class="button-primary mt-8 lg:w-max"
                                [hyundaiRouterLink]="c.videoCtaTarget"
                                [trackingElTarget]="c.videoCtaTarget"
                                [trackingElLabel]="c.videoCtaText"
                                trackingElType="button"
                                tracking
                            >
                                {{ cta }}
                            </a>
                        }
                    }
                </div>
                <div class="lg:w-1/2 lg:flex-1">
                    @if (c.video?.url; as url) {
                        <div class="group relative cursor-pointer" (click)="toggleVideo()">
                            <video
                                #videoElm
                                [muted]="videoMuted()"
                                autoplay
                                disablepictureinpicture
                                disableremoteplayback
                                playsinline="true"
                                webkit-playsinline="true"
                            >
                                <source [src]="url" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div
                                class="text-16 absolute right-0 bottom-0 flex cursor-pointer gap-20 p-14 text-white opacity-0 group-hover:opacity-100"
                            >
                                <button
                                    [attr.aria-label]="videoPlaying() ? 'Video pausieren' : 'Video abspielen'"
                                    (click)="$event.stopPropagation(); toggleVideo()"
                                >
                                    <i [ngClass]="[videoPlaying() ? 'icon-pause' : 'icon-play']" aria-hidden="true"></i>
                                </button>
                                <button
                                    [attr.aria-label]="videoMuted() ? 'Ton aktivieren' : 'Ton stummschalten'"
                                    (click)="$event.stopPropagation(); videoMuted.set(!videoMuted())"
                                >
                                    <i
                                        [ngClass]="[videoMuted() ? 'icon-sound-off' : 'icon-sound-loud']"
                                        aria-hidden="true"
                                    ></i>
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </section>

    @if (faq(); as faq) {
        <section>
            <ui-m030-c170-faq-module [faq]="faq" />
        </section>
    }

    @defer (on idle; hydrate on viewport) {
        <ng-content />

        @if (c.legalLines; as legalLines) {
            @if (legalLines.html.length > 7) {
                <section class="inner-page-wrapper text-14 text-grey-400 py-24 leading-20">
                    <p class="empty:*:h-24" [innerHTML]="legalLines.html"></p>
                </section>
            }
        }
    }
}
